import hash from "@app/helper/hash";
import useOKTAUserStore from "@app/store/useOKTAUserStore";
import useUserVarStore from "@app/store/useUserVarStore";
import { getErrorMessage } from "@helper/getErrorMessage";
import Cookies from "js-cookie";
import { useEffect } from "react";

import useMySPHLightbox from "./useMySPHLightbox";

export enum OKTAUserTypeEnum {
  SUBSCRIBER = "y-sub",
  REGISTERED = "y-reg",
  ANONYMOUS = "y-anoy",
  GUEST = "y-guest",
}

export enum OKTAUserSeviceFlagEnum {
  BH_ONLINE = "bh_online",
  BH_GENG = "bh_geng",
}

export const getUserType = () =>
  Cookies.get("mySPHUserType") as OKTAUserTypeEnum;

export const getUserServiceFlag = () => Cookies.get("svc");
export const getMysphw = () => Cookies.get("mysphw");

const useUserInfo = () => {
  const { userInfo } = useMySPHLightbox();
  const { setUserToken, isAnalyticsInitialized, setAnalyticsInitialized } =
    useUserVarStore();
  const { setUserInfo, setSuccessful, setUserError, setUserLoading } =
    useOKTAUserStore();

  useEffect(() => {
    if (isAnalyticsInitialized) {
      return;
    }
    setAnalyticsInitialized(true);

    const loginId = Cookies.get("loginid");
    const mysphw = Cookies.get("mysphw");
    if (mysphw) {
      setUserToken({
        type: "aovisitor_id",
        id: mysphw,
      });
    }
    if (loginId) {
      void hash(loginId).then((res) => {
        Cookies.set("mysph_lr", res, { expires: 60 });
      });
    }

    windowDataLayer();
  }, [setUserToken, isAnalyticsInitialized, setAnalyticsInitialized]);

  useEffect(() => {
    try {
      setUserLoading(true);

      if (!userInfo) return;

      const userType = Cookies.get("mySPHUserType") as OKTAUserTypeEnum;
      const mysphw = Cookies.get("mysphw");
      const svc = Cookies.get("svc");

      const enrichedUser = {
        ...userInfo,
        mysphw,
        usertype: userType,
        svc,
      };

      setUserInfo(enrichedUser);
      setSuccessful(true);
    } catch (error) {
      setUserError(getErrorMessage(error));
    } finally {
      setUserLoading(false);
    }
  }, [userInfo, setUserInfo, setSuccessful, setUserError, setUserLoading]);

  return {
    userInfo,
  };
};

function windowDataLayer() {
  if (typeof window === "undefined") {
    return;
  }

  const userType = Cookies.get("mySPHUserType") as OKTAUserTypeEnum | undefined;
  // eslint-disable-next-line
  window.googletag = window.googletag || {};
  // eslint-disable-next-line
  window.googletag.cmd = window.googletag?.cmd || [];

  // Set Targeting based on userType
  // eslint-disable-next-line
  window.googletag?.cmd?.push(function () {
    let user_status = "N";
    if (userType !== undefined) {
      if (userType === OKTAUserTypeEnum.SUBSCRIBER) {
        user_status = "Y";
      } else if (userType === OKTAUserTypeEnum.REGISTERED) {
        user_status = "R";
      }
      googletag.pubads().setTargeting("subscriber", user_status);
    } else {
      //adding visitor information to st datalayer
      googletag.pubads().setTargeting("subscriber", user_status);
    }
  });

  const visitorcat = Cookies.get("visitorcat");
  const mysphw = Cookies.get("mysphw");
  if (typeof window.dataLayer !== "undefined") {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window.dataLayer as { push: (data: any) => void }).push({
      visitorcat: visitorcat,
      at: mysphw,
    });
  }
  if (typeof window._data !== "undefined") {
    if (visitorcat) {
      /* eslint-disable @typescript-eslint/no-unsafe-member-access */
      window._data.visitorcat = visitorcat;
    }
    const svcCookie = Cookies.get("svc");
    if (svcCookie) {
      /* eslint-disable @typescript-eslint/no-unsafe-member-access */
      window._data.svc = svcCookie;
    }

    if (mysphw) {
      /* eslint-disable @typescript-eslint/no-unsafe-member-access */
      window._data.at = mysphw;
    }
  }
}

export default useUserInfo;
